export const FIVE9_CHAT_PROPERTIES = {
  profile: ["Colombia_Customer_Chat"],
  NameEnum: "NavbarFive9ChatSurveyApiUrl",
};
